// Configuración del entorno `develop`: usada por el despliegue de Vercel
// asociado a la rama `develop`. Apunta al backend dev desplegado en el servidor
// (BE#27 + BE#28). Diferencias respecto a `environment.prod.ts`: `production`
// es false (para no enmascarar errores runtime en el preview) y `apiBaseUrl`
// apunta al subdominio HTTPS del backend dev.

export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.accionpiano.app/v1',
  sentryDsn: '',
  appVersion: '1.7.3-develop',
};
